<script setup>
import { computed } from 'vue'
import { Button } from '@/components/ui/button'
import { Badge } from '@/components/ui/badge'
import { Trash2 } from 'lucide-vue-next'
import { formatTime } from '@/utils/datetime'

const props = defineProps({
  report: {
    type: Object,
    required: true
  },
  isActive: {
    type: Boolean,
    default: false
  },
  timezone: {
    type: String,
    default: 'UTC'
  }
})

const emit = defineEmits(['select', 'delete'])

const handleClick = () => {
  emit('select', props.report)
}

const handleDeleteClick = (event) => {
  event.stopPropagation()
  emit('delete', props.report)
}
</script>

<template>
  <div
    @click="handleClick"
    class="p-3 cursor-pointer hover:bg-muted transition-colors group"
    :class="{
      'bg-primary/10': isActive
    }"
  >
    <div class="flex items-start justify-between gap-2">
      <div class="flex-1 min-w-0">
        <h3 class="text-sm font-medium truncate">
          {{ report.title || 'Untitled Report' }}
        </h3>
        <div class="flex items-center gap-1.5 mt-0.5">
          <span class="text-xs text-muted-foreground">
            {{ formatTime(report.created_at, timezone, 'MMM D, HH:mm') }}
          </span>
          <Badge v-if="report.project_name" variant="secondary" class="text-xs px-1.5 py-0 h-4 max-w-[120px] truncate">
            {{ report.project_name }}
          </Badge>
          <Badge v-if="report.is_public" variant="default" class="text-xs px-1.5 py-0 h-4">
            Public
          </Badge>
        </div>
      </div>
      <!-- Action buttons (only show on hover) -->
      <div class="flex items-center gap-0.5 opacity-0 group-hover:opacity-100">
        <Button
          @click="handleDeleteClick"
          variant="ghost"
          size="sm"
          class="h-7 w-7 p-0 text-muted-foreground hover:text-red-600"
          aria-label="Delete report"
        >
          <Trash2 class="h-4 w-4" />
        </Button>
      </div>
    </div>
  </div>
</template>
